import { useCallback, useMemo } from 'react';
import { useKeycloak } from '@sphere/auth/data-access';
import { useAuthStore } from '@sphere/auth/data-access';
import { UserRole } from '@sphere/auth/domain';

/**
 * Résout le UserRole courant (même logique que RootLayout / Sidebar).
 */
export function useCurrentUserRole(): UserRole {
  const { tokenParsed, userInfo } = useKeycloak();
  const user = useAuthStore((state) => state.user);

  const getUserRole = useCallback((): UserRole => {
    if (user?.role && Object.values(UserRole).includes(user.role)) {
      return user.role;
    }

    const keycloakRoles =
      userInfo?.realmRoles || tokenParsed?.realm_access?.roles || [];

    const foundRole = keycloakRoles
      .map((r) => r.toLowerCase())
      .find((r): r is UserRole =>
        Object.values(UserRole).includes(r as UserRole)
      );

    return foundRole ?? UserRole.TEACHER;
  }, [user?.role, userInfo, tokenParsed]);

  return useMemo(() => getUserRole(), [getUserRole]);
}
